var _rect, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBatteries(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0000610352,
    width: 44,
    height: 44,
    rx: 4,
    fill: "#E0F6F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6 17.8H29.2V26.5H13.6L13.6 17.8ZM12.4 17.8C12.4 17.1373 12.9373 16.6 13.6 16.6H29.2C29.8627 16.6 30.4 17.1373 30.4 17.8V19H30.7C31.6941 19 32.5 19.8059 32.5 20.8V23.2C32.5 24.1941 31.6941 25 30.7 25H30.4V26.5C30.4 27.1628 29.8627 27.7 29.2 27.7H13.6C12.9373 27.7 12.4 27.1628 12.4 26.5V17.8ZM30.4 23.8H30.7C31.0314 23.8 31.3 23.5314 31.3 23.2V20.8C31.3 20.4687 31.0314 20.2 30.7 20.2H30.4V23.8Z",
    fill: "url(#paint0_linear_1392_6294)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5 20.5C26.5 20.1687 26.2314 19.9 25.9 19.9C25.5686 19.9 25.3 20.1687 25.3 20.5V21.475H24.4C24.0686 21.475 23.8 21.7437 23.8 22.075C23.8 22.4064 24.0686 22.675 24.4 22.675H25.3V23.5C25.3 23.8314 25.5686 24.1 25.9 24.1C26.2314 24.1 26.5 23.8314 26.5 23.5V22.675H27.4C27.7314 22.675 28 22.4064 28 22.075C28 21.7437 27.7314 21.475 27.4 21.475H26.5V20.5Z",
    fill: "url(#paint1_linear_1392_6294)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 22.075C19 22.4064 18.7314 22.675 18.4 22.675L15.4 22.675C15.0686 22.675 14.8 22.4064 14.8 22.075C14.8 21.7437 15.0686 21.475 15.4 21.475L18.4 21.475C18.7314 21.475 19 21.7437 19 22.075Z",
    fill: "url(#paint2_linear_1392_6294)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1392_6294",
    x1: 22.45,
    y1: 16.6,
    x2: 22.45,
    y2: 27.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2DC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47B972"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1392_6294",
    x1: 25.9,
    y1: 19.9,
    x2: 25.9,
    y2: 24.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2DC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47B972"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1392_6294",
    x1: 19,
    y1: 22.075,
    x2: 14.8,
    y2: 22.075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2DC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47B972"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteries);
export default __webpack_public_path__ + "static/media/batteries.d946375c1b0268fa1d3ab91f54ab0212.svg";
export { ForwardRef as ReactComponent };